export default {
    global: {
        close : 'fermer',
        save : 'Sauvegarde',
        continue : 'Continuer',
        confirmAndSend : 'Confirmer et envoyer',
        mandatory_field : 'Ce champ est requis',
        checkbox_mandatory : 'Cette case à cocher est obligatoire',
        cancel : 'Annuler',
        ok : 'Ok',
        yes : 'Oui',
        no : 'Non',
        post_success : 'Des données bien envoyées',
        code : 'CODE:'
    },
    menu:{
        main_menu : 'Menu principal',
        lmra : 'Ouvrir/Fermer LMRA',
        report_incident: 'Signaler un incident',
        report_near_incident : 'Signaler un incident proche',
        risk_analysis : 'Analyse de risque',
        corona_analysis : 'Analyse corona',
        scan_qr : "Scannez TAG/QR-CODE",
        process_issue : "Signaler un problème de processus",
        checklist : "Voir la liste de contrôle",
        log_in: "Connecter",
        log_out : "Déconnecter",
        emergency_numbers : "Numéros d'urgence"
    },
    default_lrma: {
        what_label : 'Est-ce que je comprends ce que j\'ai à faire ?',
        how_label : 'Est-ce que je sais comment m\'y prendre ?',
        risks_label : 'Est-ce que je vois des risques/dangers ?',
        control_label : 'Puis-je les contrôler ?',
        default_pbm_label : 'Est-ce que je dispose des EPI adaptés ?',
        default_pbm_question : 'Est-ce que je dispose des EPI adaptés ?|1',
        lmra_job_state_positive : 'Ok pour commencer le travail, nous passerons en revue la LMRA lorsque des changements se produisent',
        lmra_job_state_negative : 'Nous ne commençons pas encore les travaux.',
    },
    static_three_state_lmra : {
        getting_data_title : "La dernière version est en cours de téléchargement.",
        could_not_load_newest_list_title : 'Attention',
        could_not_load_newest_list : 'Une erreur s\'est produite lors de l\'obtention de la dernière liste. Une ancienne version enregistrée de la liste sera affichée afin que vous puissiez continuer. Si ce problème persiste, il est préférable d\'en informer une personne responsable.',
    },
    private_location : {
        title : 'Êtes-vous dans un endroit privé?',
        body : 'Les emplacements privés sont des emplacements en dehors des lieux liés au travail.'
    },
    remarks:{
        remarksDialogTitle : 'Remarques?',
        remarksDialogPlaceholder: 'Tapez vos remarques ici',
    },
    start_stop_screen :{
        start_work_btn : "Commencer à travailler",
        stop_work_btn : "Arrête de travailler",
    },
    work_report : {
        title : "Rapport de travail",
        placeholder : "Tapez votre rapport de travail ici",
        skip_work_report : "Passer",
        buildingListTitle : "Nous construisons votre formulaire de rapport de travail, cela ne devrait pas prendre trop de temps.",
        criticalErrorTitle: 'Erreur:',
        criticalErrorBody: 'Une erreur s\'est produite lors de la création de votre formulaire de rapport de travail ! Veuillez fournir à votre responsable le code d\'erreur ci-dessous :',
    },
    incident_report: {
        title: "Signaler un incident",
        placeholder : "Qu'est-il arrivé?",
    },
    oeps_report:{
        title: "Signaler un incident proche",
        placeholders : {
            machine : 'Quelle machine?',
            who : 'Qui était impliqué?',
            what : 'Qu\'est-il arrivé?',
            how : 'Comment est-ce arrivé / comment est-ce arrivé?',
            stop_card : 'Sélectionnez Stopcard',
            location: 'Sélectionnez l\'emplacement',
            department: 'Sélectionnez un département'
        },
        external_employee : 'Est un employé externe',
        when_text_label : 'Quand est-ce arrivé?',
        change_date_time_btn : 'Changer la date / l\'heure'
    },
    risk_analysis:{
        title: {
            risk_default : "Analyse de risque",
            risk_default_sub_title: '',
            corona: "Analyse corona",
            corona_sub_title: 'Indiquez ci-dessous vos conditions de travail et découvrez comment travailler en toute sécurité.'
        },
        lists :{
            risk_default : {
                gravity :{
                    label: 'Gravité' ,
                    gravity_01 : 'limitée, blessure sans absentéisme',
                    gravity_02 : 'importante, blessure et absentéisme',
                    gravity_07 : 'grave, invalidité permanente/maladie chronique avec incapacité de travail ( partielle)',
                    gravity_15 : 'très grave, mortel ( immédiat, à terme )',
                    gravity_40 : 'catastrophe, plusieurs morts'
                },
                probability :{
                    label: 'Probabilité' ,
                    probability_0_1 : 'très improbable',
                    probability_0_2 : 'pratiquement impossible',
                    probability_0_5 : 'possible, mais peu probable',
                    probability_01 : 'peu probable, cas limite',
                    probability_03 : 'inhabituel, mais possible',
                    probability_06 : 'fort probable',
                    probability_10 : 'prévisible'
                },
                exposure : {
                    label : 'Exposition',
                    exposure_0_5 : 'très rare ( 1x par an )',
                    exposure_01 : 'rare ( annuellement )',
                    exposure_02 : 'quelques fois ( mensuellement )',
                    exposure_03 : 'temps à autre ( hebdomadairement )',
                    exposure_06 : 'régulierement ( journellement )',
                    exposure_10 : 'courante',
                },
            },
            corona : {
                distance :{
                    label: 'La distance prévue entre moi et les autres:' ,
                    distance_01 : 'D > 8 m',
                    distance_02 : '6 m < D < 8 m',
                    distance_07 : '2 m < D < 6 m',
                    distance_15 : '1,5 m < D < 2 m',
                    distance_40 : '1 m < D < 1,5 m',
                    distance_100 : 'D < 1 m'
                },
                probability :{
                    label: 'Je remarque que les autres...' ,
                    probability_0_1 : 'portent un masque FFP2 + lunettes + vêtements de protection',
                    probability_0_2 : 'portent un masque FFP2 + lunettes',
                    probability_0_5 : 'portent un masque ou un écran facial',
                    probability_01 : 'respectent certainement les directives Corona',
                    probability_03 : 'respectent peut-être les directives Corona',
                    probability_06 : 'violent certaines directives de la Corona',
                    probability_10 : 'violent plusieurs directives Corona'
                },
                exposure : {
                    label : 'Chance d\'un contact plus étroit que prévu:',
                    exposure_0_5 : 'très peu probable',
                    exposure_01 : 'si plusieurs choses tournent mal',
                    exposure_02 : 'insolite, lorsque certaines choses tournent mal',
                    exposure_03 : 'possible,  la chances n\'est pas si grande',
                    exposure_06 : 'bien possible, chance raisonnable',
                    exposure_10 : 'Il faut s\'attendre, presque certainement',
                },
            },
        },
        results: {
            risk_default : {
                kinneyCode1 : 'aucun',
                kinneyCode2 : 'requiert l\'attention',
                kinneyCode3 : 'exige des mesures, pourrait être planifié',
                kinneyCode4 : 'amélioration immédiate',
                kinneyCode5 : 'arrêt de travail'
            },
            corona :{
                kinneyCode1 : 'Risque acceptable : aucune mesure de protection supplémentaire n\'est requise',
                kinneyCode2 : 'Risque potentiel : attention requise',
                kinneyCode3 : 'Risque important : prendre des mesures de protection',
                kinneyCode4 : 'Risque élevé : prendre des mesures de protection accrues',
                kinneyCode5 : 'Risque très élevé: essayez d\'ajuster l\'activité, si impossible, prenez des mesures de protection maximales'
            },
        },
        supportive_texts : {
            risk_default : {
                supportiveText1 : '',
                supportiveText2 : '',
                supportiveText3 : '',
                supportiveText4 : '',
                supportiveText5 : ''
            },
            corona : {
                supportiveText1 : 'Je connais et respecte les lignes directrices de la Corona qui s\'appliquent dans mon environnement de travail.',
                supportiveText2 : 'Je connais et respecte les lignes directrices de la Corona qui s\'appliquent. Je demande expressément aux personnes de mon environnement de travail de se conformer également aux lignes directrices de la Corona. Aucune autre mesure de protection supplémentaire n\'est nécessaire.',
                supportiveText3 : 'Je me désinfectais les mains au début et à la fin de l\'activité. Je porte un écran facial ou un masque buccal approprié en combinaison avec des lunettes (de sécurité). Les personnes présentes dans mon environnement de travail doivent au moins porter un écran facial ou un masque buccal (de préférence en combinaison avec des lunettes de sécurité). Je sais comment utiliser correctement ces équipements de protection collective et les appliquer dans la pratique.  Je connais et respecte les lignes directrices de la Corona applicables et je demande expressément aux personnes de mon environnement de travail de les respecter également.',
                supportiveText4 : 'Je me lave ou je désinfecte les mains au début et à la fin de l\'activité et après tout contact dangereux. Je porte un masque de protection nasale (de préférence un masque de protection respiratoire FFP2) en combinaison avec un écran facial ou des lunettes de protection. Je sais comment utiliser correctement ces équipements de protection individuelle (EPI) et les appliquer dans la pratique. Je connais les lignes directrices de la Corona applicables dans l\'environnement de travail et, bien entendu, je continuerai à les respecter. Je demande aux personnes dans mon environnement de travail de prendre également les précautions de sécurité nécessaires et de se conformer aux lignes directrices de Corona. Risque très élevé : essayez d\'adapter l\'activité s\'il est impossible de prendre des mesures de protection maximales.',
                supportiveText5 : 'Je vais d\'abord voir si l\'activité peut être menée de manière différente sans contact direct avec d\'autres personnes. Si cela n\'est pas possible, je prendrai toutes les mesures de sécurité possibles. Je me lave ou je désinfecte les mains au début et à la fin de l\'activité. Je porte des gants de protection. Je porte un masque de protection respiratoire (au moins FFP2) en combinaison avec un écran facial ou des lunettes et des vêtements de protection. Je sais comment utiliser correctement ces équipements de protection individuelle (EPI) et les appliquer dans la pratique. Je connais les lignes directrices de la Corona applicables dans l\'environnement de travail et, bien entendu, je continuerai à les respecter. Je demande aux personnes dans mon environnement de travail de prendre également les précautions nécessaires en matière de sécurité et de suivre scrupuleusement les lignes directrices de Corona.'
            }
        },
        leave_warning : {
            risk_default : {
                title : 'Attention',
                body : 'Vous êtes sur le point de fermer cette fenêtre sans envoyer le rapport d\'analyse des risques actuel. Voulez-vous vraiment quitter la page?'
            },
            corona : {
                title : 'Attention',
                body : 'Vous êtes sur le point de fermer cette fenêtre sans envoyer le rapport d\'analyse Corona actuel. Voulez-vous vraiment quitter la page?'
            }
        },
        report_title : 'Bulletin d\'analyse',
        placeholder_report : 'Décrire / clarifier la situation'
    },
    process_issue:{
        title: "Signaler un problème de processus",
        placeholders :{
            issue_type_select: 'Sélectionnez le type de problème',
            failure_detail: 'Sélectionnez le détail du problème',
            who : 'Qui était impliqué?',
            description : 'Décrivez le problème',
            cnf : 'CNF?',
            comment : 'Remarques / commentaires supplémentaires',
            other : 'Autres'
        }
    },
    checklist: {
        getting_data_title : "La dernière liste de contrôle est collectée."
    },
    data_transfer : {
        post_busy : 'Veuillez patienter, les données sont envoyées.',
        post_success : 'Les données ont bien été envoyées.'
    },
    gdpr_disclaimer : {
        title: 'Proposition GDPR:',
        body: 'En soumettant un élément de l\'application lmra-first, les éléments suivants seront stockés dans la base de données: l\'emplacement actuel (GPS - coordonnées (après confirmation)) et l\'heure exacte (et seulement à ce moment-là). Aucun de ces articles ne sera vendu à d\'autres parties ou organisations. Les données stockées ne seront utilisées que dans l\'ordre du projet et des conditions de travail associées',
        accept_btn : 'J\'accepte',
        decline_btn : 'Quitter l\'app.'
    },
    data_notice: {
        button_text: 'Que se passe-t-il avec ces informations?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings : {
        alert_cn_pid_nf_title : 'Oups, vous avez oublié quelque chose:',
        alert_cn_pid_nf_body : 'Nom du client et / ou ID de projet non renseignés, veuillez vérifier les valeurs',
        client_select_placeholder : 'Sélectionnez un client',
        project_select_placeholder : 'Sélectionnez un projet',
        client_not_in_list_label : 'Client pas dans la liste',
        project_not_in_list_label : 'Projet pas dans la liste',
        client_name : 'Nom du client',
        project_id : 'ID du projet',
        project_distance : 'Distance du projet',
        project_shift : 'Poste de travail',
        user_initials : 'Tes initiales',
        project_tag_code_label : 'Projet TAG-Code',
        warning : {
            intro : 'Vous utilisez maintenant la saisie manuelle pour',
            reason_server :'car les données du serveur n\'ont pas pu être chargées!',
            reason_client_not_listed :'parce que le client n\'était pas dans la liste actuelle!',
            reason_project_not_listed :'parce que le projet n\'était pas dans la liste actuelle!',
            dbl_check : 'Vérifiez toutes les valeurs avant de sauvegarder!',
            admin_msg : 'Si ce message continue d\'apparaître, contactez votre administrateur et signalez-le!'
        },
        input_errors : {
            no_client_selected : 'Veuillez sélectionner un client',
            no_project_selected : 'Veuillez sélectionner un projet',
        },
        loading_cap : 'Chargement des données depuis le serveur',
        custom_shifts_labels: {
            open_field : 'Champ ouvert'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Erreur de scan",
                body : "Format de données QR non valide détecté"
            },
            error_popup_notice_manual_mode : {
                title : "Quelque chose s'est mal passé",
                body : "Quelque chose s'est mal passé lors du chargement des données RRQRCode, passage en mode manuel"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Chargement du flux de la caméra ...',
            default_error_button_test : 'Quitter'
        },
        overlay_view: {
            title : 'Scan TAG - Code',
            info_manual : 'Vous rencontrez des problèmes de numérisation? Utiliser la saisie manuelle',
            manual_btn : 'Activer la saisie manuelle.',
            errors : {
                invalid_tag_title : 'TAG-CODE invalide',
                invalid_tag_body : 'Le code que vous avez scanné n\'est pas un TAG-CODE valide, scannez un TAG-CODE valide ou passez à la saisie manuelle.',
                error_btn_txt : 'Activer la saisie manuelle'
            }
        }
    },
    errors:{
        checklistNotLoaded : 'Une erreur s\'est produite lors de l\'obtention de la liste. Veuillez réessayer plus tard.',
        EmergencyNumbersOverviewNotLoaded: 'Une erreur s\'est produite lors de l\'obtention de la liste. Veuillez réessayer plus tard.',
        missing_critical_resource_title : 'Erreur lors du chargement des données:',
        missing_critical_resource : 'Une ressource manque dans l\'application. Signalez le code ci-dessous à l\'administrateur.',
        app_corrupt : 'Il semble que la configuration de l\'application soit corrompue. Veuillez contacter votre administrateur.',
        data_save_failed : 'Les données n\'ont pas pu être envoyées, veuillez réessayer plus tard ...',
        camera: {
            NotAllowedError : 'ERREUR: vous devez accorder l\'autorisation d\'accès à la caméra',
            NotFoundError : 'ERREUR: aucune caméra sur cet appareil',
            NotSupportedError : 'ERREUR: contexte sécurisé requis (HTTPS, localhost)',
            NotReadableError : 'ERREUR: l\'appareil photo est-il déjà utilisé?',
            OverconstrainedError : 'ERREUR: les caméras installées ne conviennent pas',
            StreamApiNotSupportedError : 'ERREUR: l\'API Stream n\'est pas prise en charge dans ce navigateur',
        },
        no_internet : 'Oups ... vous êtes hors ligne, vérifiez votre connexion Internet!',
        input_validation : {
            char_limit : 'Un maximum de %n caractères est autorisé'
        },
        auth0 :{
            unverified_email : {
                error: 'Erreur: L\'adresse e-mail n\'est pas vérifiée! Vérifier vos e-mails!',
                info : 'Afin d\'accéder à cette application <b>vous devez vérifier votre adresse e-mail</b>.<br/><br/>Vous recevrez <b>un e-mail</b> sous peu <b >de |SENDER| </b><br/><br/><i>Pour vérifier votre adresse e-mail. Suivez les instructions dans l\'e-mail</i>'
            }
        }
    },
    noDataText: "Données non disponibles ...",
    defaultDynamicQuestion : '{"dynamic_questions":[{"id":null,"question":"Est-ce que je dispose des EPI adaptés ?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-mail',
        passwordLabel : 'Mot de passe',
        rememberMeLabel : "Se souvenir de moi",
        logInBtn: "Connecter",
        logOutBtn: "Déconnecter",
        verifyMFABtn : "Vérifier",
        errorPopupTitle : "Erreur",
        confirmIdentify : "Toujours toi ?",
        errors :{
            required : "Requis",
            invalidEmail : "E-mail invalide",
            unknownError : "Une erreur inconnue s'est produite"
        },
        registerNewAccountBtn : "Créer un nouveau compte.",
        forgotPassword : "Mot de passe oublié"
    },
    lmraComponent : {
        loadingProjectData : 'Préparation de votre formulaire LMRA, veuillez patienter',
        startWorkQrDialog:{
            title : "Sélectionner la méthode de démarrage :",
            body : "Si vous disposez d'un code QR Risk-reflex, veuillez sélectionner le QR-Code sinon utilisez la méthode de saisie manuelle",
            positive_btn : "QR-code",
            negative_btn : "Méthode manuelle"
        },
        errors : {
            unknownError : "Une erreur inconnue s'est produite",
            noListDataFound : "Erreur: AUCUNE DONNÉE DE LISTE TROUVÉE! RETOUR À LA LMRA PAR DÉFAUT",
            noDefaultListFound: 'Aucune liste par défaut disponible ! Utilisation de LMRA PAR DÉFAUT !',
        }
    },
    customLmraLists : {
        buildingListTitle : "Construire votre formulaire LMRA, cela ne devrait pas prendre trop de temps.",
        criticalErrorTitle: "Erreur :",
        criticalErrorBody: 'Quelque chose s\'est mal passé lors de la construction de votre formulaire LMRA ! Nous allons maintenant charger le LMRA par défaut ! merci de fournir à votre manager le code d\'erreur ci-dessous : ',
    },
    workSessions :{
        global : {
            expiredLabel : "Expiré"
        },
        resumeSessionDialog : {
            titleActiveSession : "Session active trouvée",
            titleActiveSessionExpired : "Session active (expirée) trouvée",
        },
        workSessionServiceNaDialog :{
            title : 'SERVICE WORKSESSION INDISPONIBLE',
            body : 'Désolé, nous ne pouvons pas déterminer si vous avez une session ouverte<br/><br/>' +
                '<b>Le module LMRA est verrouillé : vous ne pouvez pas démarrer ou fermer une session. </b><br/> Cependant vous pouvez toujours envoyer des rapports d\'incidents (hors session)<br/>' +
                'Vous recevrez une notification lorsque le service de session sera disponible<br/><br/>' +
                'si cette erreur persiste, veuillez en informer votre administrateur..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Désolé : <b>Le module LMRA est actuellement verrouillé : vous ne pouvez pas démarrer ou fermer une session. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : '\'La réponse du serveur ne contient pas de données de session\'',
                    could_not_save_session : 'Impossible d\'enregistrer les données de session localement...',
                    invalid_session_data : 'Données de session invalides, les données sont peut-être corrompues'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Une erreur inconnue s'est produite",
            notFound : "Aucun code de groupe trouvé."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Numéro d'urgence par défaut",
        getting_data_title : "Obtenir les derniers numéros"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Liste active",
                other_checklists : "Autres listes"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Visualisation : "
            },
            warning_message : "Vous consultez une liste de contrôle qui n'est pas la liste active actuelle. Pour afficher la liste active, utilisez l'onglet \"Liste active\" en haut"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "La version est à jour",
            version_minor_update : "Version plus récente disponible (peut ne pas être disponible pour votre locataire)",
            update_required : "Avertissement! Cette application est obsolète, elle devrait se mettre à jour automatiquement. Si ce message persiste, contactez l'administrateur."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Mauvais type de QR-code",
                    body : "Ce type de code QR n'est pas pris en charge ici"
                },
                wrong_tenant : {
                    title : "Mauvais locataire",
                    body : "Ce QR-code ne peut pas être utilisé par votre entreprise"
                },
                invalid_qr_code : {
                    title : "QR-code invalide",
                    body : "Ceci n'est pas un code QR Risk Reflex valide et ne peut pas être utilisé"
                },
                invalid_qr_data : {
                    title : "Données QR-code invalides",
                    body : "Ce QR-code ne peut pas être traduit, le QR-code est peut-être corrompu"
                }
            },
            title : "Scannez le QR-Code Risk-Reflex",
            info_manual : 'Vous rencontrez des problèmes de numérisation? Utiliser la saisie manuelle',
            manual_btn: "Passer en mode manuel"
        }
    }
}